//import "../polyfills.js";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { catchError } from "rxjs/operators";
import { ToastService } from "../Common/toast/toast.service";
import { ToastMessageType } from "../Common/toast/ToastMessageType";
import { Tenant } from "../Models/tenant";
import { FeaturePermissionViewModel } from "@app/Models/FeaturePermissionViewModel";

@Injectable({
    providedIn: 'root'
})
export class PermissionsService {
    private baseUrl = "";

	constructor(private http: HttpClient,
        private activatedRoute: ActivatedRoute,
        private toast: ToastService) {

	}

    getUsers(tenant) {
        return this
            .http
            .post<any[]>(`${this.baseUrl}/api/permissions/users`, tenant);
    }

    enableAccess(tenant: Tenant, enable: string, userId: string) {
        var queryParams = {
            "UserId": userId.toString(),
            "Enable": enable.toString()
        };

        return this
            .http
            .post<any>(`${this.baseUrl}/api/permissions/${tenant.TenantId}/enableAccess`, queryParams).pipe(catchError((error: any) => {
                return this.handleError(error, 'User access could not be updated!')
            }));
    }

    restrictTenant(tenant: Tenant, restrict: boolean) {
        var queryParams = {
            "Restrict": restrict.toString()
        };

        return this
            .http
            .post<any>(`${this.baseUrl}/api/permissions/${tenant.TenantId}/restrictTenant`, queryParams).pipe(catchError((error: any) => {
                return this.handleError(error, 'Tenant restriction could not be updated!')
            }));
    }

    getPermissionsForAllModules(tenant: Tenant) {
        const options = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

         return this
             .http
             .get<FeaturePermissionViewModel[]>(`${this.baseUrl}/api/permissions/${tenant.TenantId}/get-all-module-permissions`, options)
             .pipe(catchError((error: any) => {
                 return this.handleError(error, 'Could not get permissions for modules')
             }));
    }

    private handleError(error: any, message: any): Promise<any> {
        console.error("An error occurred", error); // for demo purposes only
        this.toast.sendMessage('Tenant Access', message, ToastMessageType.error);
        return Promise.reject(error.message || error);
    }
}
